import { StateCreator } from 'zustand'
import { mercuryApi } from '$api'
import { SharedSlice } from '../../../../slice'
import { PayClassification } from '$models'
import { exceptionMessageHandler } from '$utils'

interface PayClassificationsState {
  payClassifications: PayClassification[]
  showDeactivated: boolean
}

export interface PayClassificationsSlice extends PayClassificationsState {
  setShowDeactivated: () => void

  /**
   * Get Pay Classifications list
   */
  getPayClassifications: () => Promise<void>

  /**
   * Resets PayClassifications Slice state
   */
  resetPayClassificationsSlice: () => void
}

const initialState: PayClassificationsState = {
  payClassifications: [],
  showDeactivated: false,
}

const createPayClassificationsSlice: StateCreator<
  PayClassificationsSlice & SharedSlice,
  [],
  [],
  PayClassificationsSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  setShowDeactivated: () =>
    set((state) => ({ showDeactivated: !state.showDeactivated })),
  resetPayClassificationsSlice: () => set(initialState),

  // State API calls
  getPayClassifications: async (): Promise<void> => {
    return mercuryApi
      .get<PayClassification[]>(`/pay-classifications`)
      .then((result) => set(() => ({ payClassifications: result })))
      .catch((error) => {
        set(() => ({
          payClassifications: [],
        }))
        exceptionMessageHandler(error, 'Failed to retrieve pay classifications')
      })
      .finally(() => {
        set(() => ({ isLoading: false }))
      })
  },
})

export default createPayClassificationsSlice
